import { PageWrapper } from "@src/appV2/redesign/components/PageWrapper";
import { StickyScrollPageHeader } from "@src/appV2/redesign/components/StickyScrollPageHeader";
import { DocumentDetailsMetadata } from "@src/appV2/redesign/Documents/Details/Metadata";
import { DocumentDetailsRequiredBySection } from "@src/appV2/redesign/Documents/Details/RequiredBySection/Section";
import { DocumentPageScrollWrapper } from "@src/appV2/redesign/Documents/Details/ScrollWrapper";
import { DocumentDetailsStatusCard } from "@src/appV2/redesign/Documents/Details/StatusCard";
import { useRequirementDetailsContext } from "@src/appV2/redesign/Documents/Details/useRequirementDetailsContext";
import { useRef } from "react";

import { DEFAULT_PAGE_TITLE } from "../constants";
import { ApprovedViewReferencesList } from "./ApprovedViewReferencesList";

export function ProfessionalReferencesApprovedView() {
  const { requirement: workerRequirement } = useRequirementDetailsContext();
  const scrollRef = useRef<HTMLDivElement>(null);
  const title = workerRequirement?.requirement?.attributes?.name ?? DEFAULT_PAGE_TITLE;

  return (
    <PageWrapper variant="tertiary">
      <StickyScrollPageHeader
        shouldWrapTitle
        title={title}
        headerVariant="tertiary"
        scrollContainerRef={scrollRef}
      />

      <DocumentPageScrollWrapper ref={scrollRef}>
        <DocumentDetailsMetadata />
        <DocumentDetailsStatusCard hideViewDocument />
        <ApprovedViewReferencesList />
        <DocumentDetailsRequiredBySection />
      </DocumentPageScrollWrapper>
    </PageWrapper>
  );
}
